import { TranslationService } from '~/services/Translation'
import MediaRepository from './repository'
import Media from '~/models/Media'
import FileRestrictions from '../shared/file'
import EventsService from '~/services/events'

export default class MediaService {
	public static async uploadImage(file: File): Promise<Media> {
		if (this.exceedsSize(file) || !this.isImage(file)) this.emitInvalidImageFileError()

		return await MediaRepository.upload(file)
	}

	public static async uploadMultipleType(file: File): Promise<Media> {
		if (this.exceedsSize(file) || !this.isImageOrPDF(file)) this.emitFileSizeError()

		return await MediaRepository.upload(file)
	}

	public static async uploadMultipleImages(files: File[]): Promise<Media[]> {
		files.forEach((file: File) => {
			if (this.exceedsSize(file) || !this.isImage(file)) this.emitInvalidImageFileError()
		})

		return await MediaRepository.uploadMultiple(files)
	}

	public static async delete(id: string): Promise<void> {
		await MediaRepository.deleteMedia(id)
	}

	private static exceedsSize(file: File): boolean {
		const maxAllowedMB: number = 20
		return FileRestrictions.sizeIsGreaterThan(maxAllowedMB, file.size)
	}

	private static isImage(file: File): boolean {
		return (
			file.type === 'image/jpeg' ||
			file.type === 'image/jpg' ||
			file.type === 'image/png' ||
			file.type === 'image/gif' ||
			file.type === 'image/webp' ||
			file.type === 'image/svg'
		)
	}

	private static isPDF(file: File): boolean {
		return file.type === 'application/pdf'
	}

	private static isImageOrPDF(file: File): boolean {
		return this.isImage(file) || this.isPDF(file)
	}

	private static emitInvalidImageFileError() {
		const t = TranslationService.getInstance()
		EventsService.emitError(t.translate('photoUpload_errorFeedback_invalidFileFormat'))
		throw Error
	}

	private static emitFileSizeError() {
		const t = TranslationService.getInstance()
		EventsService.emitError(t.translate('error_file_too_big'))
		throw Error
	}
}
